import React from 'react'

export default function SchoolManagement() {
  return (
    <div>SchoolManagement</div>
  )
}
